module.exports = __webpack_public_path__ + "static/media/phone.31ceb8a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/header/phone.svg
// module id = 152
// module chunks = 0